import styled from 'styled-components';

const GREEN = '#34574A';
const GOLD = '#BA824F';
const BORDER = '#e5e7eb';
const TEXT = '#1f2937';
const MUTED = '#6b7280';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 112px);
  min-height: 480px;
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 10px;

  h1 { font-size: 22px; color: ${TEXT}; margin: 0; }
  p { font-size: 13px; color: ${MUTED}; margin: 2px 0 0; }
`;

export const StatusSelect = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: ${TEXT};

  select {
    border: none; background: transparent; font: inherit; color: inherit;
    outline: none; cursor: pointer;
  }
`;

export const Dot = styled.span`
  width: 10px; height: 10px; border-radius: 50%;
  background: ${({ $c }) => $c || '#9ca3af'};
  display: inline-block;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(0, 2fr) minmax(240px, 1fr);
  gap: 14px;
  flex: 1;
  min-height: 0;

  @media (max-width: 1100px) {
    grid-template-columns: minmax(240px, 1fr) minmax(0, 2fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Col = styled.section`
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  ${({ $hideMobile }) => $hideMobile && `@media (max-width: 768px) { display: none; }`}
  ${({ $hideTablet }) => $hideTablet && `@media (max-width: 1100px) and (min-width: 769px) { display: none; }`}
`;

export const Tabs = styled.div`
  display: flex;
  gap: 6px;
  padding: 12px 12px 0;
`;

export const Tab = styled.button`
  flex: 1;
  border: none;
  background: ${({ $active }) => ($active ? GREEN : '#f3f4f6')};
  color: ${({ $active }) => ($active ? '#fff' : MUTED)};
  font-size: 12px;
  font-weight: 700;
  padding: 8px 4px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 0;

  svg { font-size: 13px; flex: 0 0 auto; }
  .lbl { display: none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  @media (min-width: 1400px) { .lbl { display: inline; } }

  span.n {
    background: ${({ $active }) => ($active ? 'rgba(255,255,255,.22)' : '#e5e7eb')};
    border-radius: 10px;
    padding: 0 6px;
    font-size: 11px;
    min-width: 20px;
    text-align: center;
    flex: 0 0 auto;
  }
`;

export const SearchBox = styled.div`
  padding: 10px 12px;
  input {
    width: 100%;
    border: 1px solid ${BORDER};
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 13px;
    outline: none;
    &:focus { border-color: ${GREEN}; }
  }
`;

export const ConvList = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const ConvItem = styled.button`
  width: 100%;
  display: flex;
  gap: 10px;
  padding: 12px;
  border: none;
  border-bottom: 1px solid #f3f4f6;
  background: ${({ $active }) => ($active ? '#eef7f1' : '#fff')};
  text-align: left;
  cursor: pointer;
  transition: background .15s;
  &:hover { background: ${({ $active }) => ($active ? '#eef7f1' : '#f9fafb')}; }
`;

export const Avatar = styled.div`
  width: 40px; height: 40px; border-radius: 50%;
  background: ${({ $c }) => $c || '#9ca3af'};
  color: #fff; font-weight: 700; font-size: 14px;
  display: flex; align-items: center; justify-content: center;
  flex: 0 0 40px;
  overflow: hidden;
  img { width: 100%; height: 100%; object-fit: cover; }
`;

export const ConvMeta = styled.div`
  flex: 1;
  min-width: 0;
  .top { display: flex; justify-content: space-between; align-items: baseline; gap: 6px; }
  .nome { font-size: 13px; font-weight: 700; color: ${TEXT}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .hora { font-size: 11px; color: ${MUTED}; flex: 0 0 auto; }
  .preview { font-size: 12px; color: ${MUTED}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 2px; }
  .bottom { display: flex; align-items: center; gap: 6px; margin-top: 4px; }
`;

export const StatusPill = styled.span`
  font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 10px;
  background: ${({ $bg }) => $bg}; color: ${({ $c }) => $c};
  text-transform: capitalize;
`;

export const UnreadBadge = styled.span`
  background: #dc2626; color: #fff; font-size: 10px; font-weight: 700;
  border-radius: 10px; padding: 1px 7px; margin-left: auto;
`;

export const ThreadHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid ${BORDER};

  .info { flex: 1; min-width: 0; }
  .nome { font-size: 14px; font-weight: 700; color: ${TEXT}; }
  .sub { font-size: 12px; color: ${MUTED}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
`;

export const IconBtn = styled.button`
  border: 1px solid ${BORDER};
  background: #fff;
  color: ${GREEN};
  width: 32px; height: 32px;
  border-radius: 8px;
  display: inline-flex; align-items: center; justify-content: center;
  cursor: pointer;
  font-size: 14px;
  &:hover { background: #f3f4f6; }
  &:disabled { opacity: .5; cursor: not-allowed; }
`;

export const PrimaryBtn = styled.button`
  border: none;
  background: ${({ $danger }) => ($danger ? '#dc2626' : GOLD)};
  color: #fff;
  font-size: 13px; font-weight: 700;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px;
  &:hover { filter: brightness(1.08); }
  &:disabled { opacity: .55; cursor: not-allowed; }
`;

export const Messages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 14px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
`;

export const DateSep = styled.div`
  text-align: center;
  font-size: 11px;
  color: ${MUTED};
  margin: 10px 0 4px;
  span { background: #eef0f1; padding: 3px 10px; border-radius: 10px; }
`;

export const SysMsg = styled.div`
  text-align: center;
  font-size: 11px;
  color: ${MUTED};
  font-style: italic;
  margin: 4px 0;
`;

export const BubbleRow = styled.div`
  display: flex;
  justify-content: ${({ $me }) => ($me ? 'flex-end' : 'flex-start')};
`;

export const Bubble = styled.div`
  max-width: 75%;
  background: ${({ $me }) => ($me ? '#e3f2e9' : '#F1F0F0')};
  color: ${TEXT};
  padding: 9px 12px;
  border-radius: 14px;
  font-size: 13px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;

  .meta {
    display: flex; gap: 4px; justify-content: flex-end;
    font-size: 10px; color: ${MUTED}; margin-top: 3px;
  }
  .remetente { font-size: 10px; font-weight: 700; color: ${GREEN}; display: block; margin-bottom: 2px; }
  img.anexo { max-width: 220px; border-radius: 8px; display: block; }
`;

export const NewMsgsBar = styled.button`
  align-self: center;
  border: none;
  background: ${GREEN};
  color: #fff;
  font-size: 12px; font-weight: 700;
  padding: 5px 14px;
  border-radius: 14px;
  cursor: pointer;
  position: sticky;
  bottom: 8px;
`;

// markdown dentro das bolhas (mesmo render do widget público)
export const MdBody = styled.div`
  font-size: 13px;
  line-height: 1.45;
  word-break: break-word;
  p { margin: 0 0 6px; }
  p:last-child { margin-bottom: 0; }
  strong { font-weight: 700; }
  a { color: ${GREEN}; font-weight: 600; text-decoration: underline; }
  ul, ol { margin: 4px 0; padding-left: 18px; }
  li { margin: 2px 0; }
  code { background: rgba(0,0,0,.06); border-radius: 4px; padding: 1px 4px; font-size: 12px; }
  h1,h2,h3,h4 { font-size: 14px; margin: 6px 0 4px; }
`;

// cards de imóvel anexados a uma mensagem (mesmo formato dos cards da Sonia)
export const MsgCards = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 4px 2px;
  max-width: 100%;
  justify-content: ${({ $me }) => ($me ? 'flex-end' : 'flex-start')};
`;

export const MsgCard = styled.div`
  flex: 0 0 190px;
  border: 1px solid ${BORDER};
  border-radius: 10px;
  overflow: hidden;
  background: #fff;

  .foto { width: 100%; aspect-ratio: 16/10; object-fit: cover; display: block; background: #eef2f0; }
  .nofoto { width: 100%; aspect-ratio: 16/10; background: #eef2f0; display: flex; align-items: center; justify-content: center; font-size: 26px; }
  .body { padding: 8px; }
  .titulo { font-size: 12px; font-weight: 700; color: ${TEXT}; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .loc { font-size: 11px; color: ${MUTED}; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .preco { font-size: 13px; font-weight: 700; color: ${GREEN}; margin-top: 4px; }
  a { font-size: 11px; font-weight: 700; color: ${GOLD}; text-decoration: none; display: inline-block; margin-top: 5px; }
`;

// painel de busca de imóveis acima do composer
export const PickerPanel = styled.div`
  position: absolute;
  bottom: calc(100% + 6px);
  left: 12px;
  right: 12px;
  max-height: 300px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: 12px;
  box-shadow: 0 -8px 30px rgba(0,0,0,.14);
  z-index: 60;
  overflow: hidden;

  .picker-search { padding: 10px; border-bottom: 1px solid #f3f4f6; }
  .picker-search input { width: 100%; border: 1px solid ${BORDER}; border-radius: 8px; padding: 7px 10px; font-size: 13px; outline: none; }
  .picker-search input:focus { border-color: ${GREEN}; }
  .picker-list { overflow-y: auto; min-height: 0; }
  .picker-empty { padding: 14px; font-size: 12px; color: ${MUTED}; text-align: center; }
`;

export const PickerItem = styled.button`
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 8px 10px;
  border: none;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  text-align: left;
  cursor: pointer;
  &:hover { background: #f9fafb; }

  .thumb { width: 52px; height: 40px; border-radius: 6px; object-fit: cover; background: #eef2f0; flex: 0 0 auto; }
  .info { flex: 1; min-width: 0; }
  .t { font-size: 12px; font-weight: 700; color: ${TEXT}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .s { font-size: 11px; color: ${MUTED}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
`;

// chips de imóveis anexados acima do input
export const AttachChips = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 8px 12px 0;
  background: #fff;
`;

export const AttachChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eef7f1;
  border: 1px solid #c8e0d2;
  color: ${TEXT};
  font-size: 11px;
  font-weight: 600;
  border-radius: 14px;
  padding: 3px 8px;
  max-width: 240px;

  span.t { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  button { border: none; background: none; color: ${MUTED}; cursor: pointer; font-size: 12px; padding: 0; line-height: 1; }
`;

export const Composer = styled.div`
  position: relative;
  border-top: 1px solid ${BORDER};
  padding: 10px 12px;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: #fff;

  textarea {
    flex: 1;
    border: 1px solid ${BORDER};
    border-radius: 10px;
    padding: 9px 12px;
    font-size: 13px;
    font-family: inherit;
    resize: none;
    max-height: 110px;
    outline: none;
    &:focus { border-color: ${GREEN}; }
    &:disabled { background: #f3f4f6; }
  }
`;

export const SideSection = styled.div`
  padding: 14px;
  border-bottom: 1px solid #f3f4f6;
  &:last-child { border-bottom: none; }

  h4 { font-size: 12px; font-weight: 700; color: ${MUTED}; text-transform: uppercase; letter-spacing: .4px; margin: 0 0 10px; display: flex; justify-content: space-between; align-items: center; }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${TEXT};
  padding: 4px 0;
  svg { color: ${MUTED}; flex: 0 0 auto; }
  span { overflow: hidden; text-overflow: ellipsis; }
`;

export const ImovelCard = styled.div`
  border: 1px solid ${BORDER};
  border-radius: 10px;
  overflow: hidden;
  img { width: 100%; height: 110px; object-fit: cover; display: block; background: #eef2f0; }
  .body { padding: 10px; }
  .titulo { font-size: 13px; font-weight: 700; color: ${TEXT}; }
  .loc { font-size: 11px; color: ${MUTED}; margin-top: 2px; }
  .preco { font-size: 14px; font-weight: 700; color: ${GREEN}; margin-top: 4px; }
  a { font-size: 12px; font-weight: 700; color: ${GOLD}; text-decoration: none; display: inline-block; margin-top: 6px; }
`;

export const SideActions = styled.div`
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  button {
    display: flex; align-items: center; gap: 8px;
    border: 1px solid ${BORDER};
    background: #fff;
    padding: 9px 12px;
    border-radius: 8px;
    font-size: 13px; font-weight: 600; color: ${TEXT};
    cursor: pointer;
    &:hover { background: #f9fafb; }
    &.danger { color: #dc2626; border-color: #fecaca; }
  }
`;

export const Empty = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${MUTED};
  font-size: 14px;
  padding: 24px;
  text-align: center;
  svg { font-size: 34px; color: #d1d5db; }
`;

export const Reconnect = styled.div`
  background: #fef3c7;
  color: #92400e;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 5px 8px;
`;

export const Skeleton = styled.div`
  height: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: sk 1.2s infinite;
  margin: 6px 0;
  @keyframes sk { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
`;
